<template>
  <ul>
    <li v-for="card in cards" :key="card.outerTitle" class="mb-3">
      <TheNuxtLink
        v-if="card.btnOneUrl"
        :to="card.btnOneUrl"
        :title="card.innerTitle"
        class="flex h-[140px] w-full overflow-hidden rounded shadow-normal shadow-gray-400"
      >
        <div class="flex-1 p-3">
          <h3 class="line-clamp-4 max-h-24 text-base font-bold">
            {{ card.innerTitle }}
          </h3>
        </div>
        <figure class="relative w-[120px] basis-[120px] overflow-hidden">
          <img
            :src="provideImgUrl(card.bgImg)"
            :alt="card.outerTitle"
            loading="lazy"
            class="pointer-events-none h-full w-full object-cover"
          />
        </figure>
      </TheNuxtLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
  import type { ISolutionCard } from '@/assets/types/Home';

  interface IProps {
    cards: ISolutionCard[];
  }

  withDefaults(defineProps<IProps>(), {
    cards: () => [],
  });

  const { provideImgUrl } = useHomeData();
</script>
